import { createContext, useContext } from 'react';
import { GqlPurchaseFragment } from '../apollo/generated/graphql';

export const ChannelPurchasesContext = createContext<UseChannelPurchases>({
  purchases: [],
});

type UseChannelPurchases = {
  purchases: GqlPurchaseFragment[];
};

export function useChannelPurchases(): UseChannelPurchases {
  const { purchases } = useContext(ChannelPurchasesContext);

  return {
    purchases,
  };
}
